// Inc C — distance-fade dei dot hotspot. Pure, testabile.
//
// Opacità in funzione della distanza camera→hotspot: piena (max) entro `near`,
// minima (min) oltre `far`, interpolazione lineare monotona non-crescente nel
// mezzo. Default: near 3 m, far 25 m, max 1, min 0.35.
export function fadeOpacity(distance: number, near = 3, far = 25, max = 1, min = 0.35): number {
  if (distance <= near) return max;
  if (distance >= far) return min;
  const tNorm = (distance - near) / (far - near); // 0..1
  return max + (min - max) * tNorm;
}
